import React from 'react'

const styles = {
  height: '60vh',
  margin: 'auto',
  width: '97%'
}

const Feedback = () => (
  <iframe title='Feedback' style={styles} src='https://www.govdocs.com/feedback-form/' />
)

export default Feedback
